import { useRouter } from '@application/utils';
import type { BreedsGetBreedsQuery } from '@gql/graphql';
import type { CardItemBreedData } from '@presentation/components';
import { BREAKPOINTS } from '@presentation/styles';
import cleanDeep from 'clean-deep';
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

export const useFormatBreeds = (breeds?: BreedsGetBreedsQuery['findManyDogBreed'] | null) => {
  const { routeLocationDescriptor } = useRouter();
  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.phone}px)` });
  const preloadImagesCount = isMobile ? 2 : 4;

  const formattedBreeds: CardItemBreedData[] | undefined = useMemo(() => {
    if (!breeds || !breeds.length) return;
    return breeds.map(
      (breed, index) =>
        ({
          name: breed.translations?.[0]?.name ?? breed.name,
          image: breed.imgs?.[0]?.small,
          attributes: cleanDeep({
            exercise: breed.exerciseIndex,
            education: breed.educationIndex,
            care: breed.careIndex,
            sociability: breed.sociabilityIndex,
          } as CardItemBreedData['attributes']),
          link: routeLocationDescriptor('breed', {
            params: [breed.translations?.[0]?.url ?? ''],
          }),
          lazyLoadImage: index >= preloadImagesCount,
        } as CardItemBreedData),
    );
  }, [breeds, preloadImagesCount, routeLocationDescriptor]);

  const imagesToPreload: string[] = useMemo(() => {
    if (!formattedBreeds?.length) return [];
    return formattedBreeds.slice(0, preloadImagesCount).map((breed) => breed.image as string);
  }, [formattedBreeds, preloadImagesCount]);

  return { formattedBreeds, imagesToPreload };
};
